module.exports = __webpack_public_path__ + "img/logo_walletconnect.32f7fb96.png";